import { Divider, NotificationAlert } from '@cellula/react';
import type { PaymentServiceApiModel } from '@visiba/api-vcs-client-v2';
import { usePresentation } from '@visiba/presentation';
import { Fragment, useEffect, useRef } from 'react';
import { usePaymentContext } from './_payment.context';
import { PaymentFrame } from './_payment_frame.component';
import { PaymentOptions } from './_payment_options.component';
import { PaymentState } from './payment.controller';

interface Props {}

export function PaymentStateConveyer(_: Props): JSX.Element | null {
	const { controller } = usePaymentContext();
	const { availableOptions, currentStep, selectedPaymentOption, errorMessage } = usePresentation(controller.presentation);
	const ref = useRef<HTMLDivElement | null>(null);

	useEffect(function whenCurrentStepChanges() {
		// A user can lose its focus trap when content they've tabbed into
		// disappears. To regain the focus we'll do a check if the browser
		// did a fallback to document body.
		if (document.activeElement === document.body) {
			ref.current?.focus();
		}
	}, []);

	return (
		<Fragment>
			{errorMessage != null ? <NotificationAlert variant='danger'>{errorMessage}</NotificationAlert> : null}

			<div ref={ref} role='region' tabIndex={-1}>
				{selectedPaymentOption != null ? (
					<PaymentConveyer selectedPaymentOption={selectedPaymentOption} />
				) : (
					<PaymentOptions options={availableOptions} onSelect={controller.selectPaymentMethod.bind(controller)} />
				)}
			</div>

			{currentStep === PaymentState.PaymentFrame ? <Divider /> : null}
		</Fragment>
	);
}

function PaymentConveyer(props: { selectedPaymentOption: PaymentServiceApiModel }): JSX.Element {
	return (
		<Fragment>
			<PaymentFrame url={props.selectedPaymentOption.Url} />
		</Fragment>
	);
}
